// admin — French. Keys are the English source text.
export default {
  "Say what's wrong and what to change.": "Indiquez le problème et ce qu'il faut changer.",
  "At least {n} characters.": "Au moins {n} caractères.",
  "The seller sees this message.": "Le vendeur voit ce message.",
  "Cancel": "Annuler",
  "Confirm": "Confirmer",
  "Reject {name}?": "Refuser {name} ?",
  "Reject this store?": "Refuser cette boutique ?",
  "The seller can fix the issue and ask for a new review.": "Le vendeur peut corriger et demander une nouvelle vérification.",
  "Reject store": "Refuser la boutique",
  "Suspend {name}?": "Suspendre {name} ?",
  "Suspend this store?": "Suspendre cette boutique ?",
  "Their parts are hidden from buyers until you reactivate the store.": "Ses pièces sont masquées jusqu'à la réactivation.",
  "Suspend store": "Suspendre la boutique",
  "Reject this part?": "Refuser cette pièce ?",
  "The seller can edit the listing and send it back for review.": "Le vendeur peut modifier l'annonce et la renvoyer en vérification.",
  "Reject part": "Refuser la pièce",
  "Archive {name}?": "Archiver {name} ?",
  "Archive this part?": "Archiver cette pièce ?",
  "Archive part": "Archiver la pièce",
  "Language": "Langue",
  "PartHub Admin": "PartHub Admin",
  "Control panel": "Panneau de contrôle",
  "Admin": "Admin",
  "Sign out": "Se déconnecter",
  "Open navigation": "Ouvrir le menu",
  "Close navigation overlay": "Fermer le menu",
  "Failed to load analytics": "Impossible de charger les analyses",
  "Search demand analytics": "Analyse des recherches",
  "Understand what buyers search for, what they fail to find, and which vehicle demand is strongest.": "Ce que cherchent les acheteurs, ce qu'ils ne trouvent pas et les véhicules les plus demandés.",
  "Top buyer queries": "Recherches les plus fréquentes",
  "The most common search keywords currently used across the marketplace.": "Les mots-clés les plus utilisés.",
  "No query analytics available yet.": "Pas encore de données.",
  "{n} searches": "{n} recherches",
  "Zero-result demand": "Recherches sans résultat",
  "Queries that buyers search for but fail to find. This is direct supply opportunity.": "Ce que les acheteurs ne trouvent pas : une opportunité directe.",
  "No zero-result searches found yet.": "Aucune recherche sans résultat.",
  "No keyword": "Sans mot-clé",
  "{n} misses": "{n} sans résultat",
  "any make": "toute marque",
  "any model": "tout modèle",
  "any year": "toute année",
  "Top vehicle demand": "Véhicules les plus recherchés",
  "Most searched make/model/year combinations.": "Combinaisons marque/modèle/année les plus recherchées.",
  "No vehicle search analytics yet.": "Pas encore de données véhicule.",
  "Recent search activity": "Recherches récentes",
  "Latest buyer search events flowing through the system.": "Les dernières recherches des acheteurs.",
  "No recent search events yet.": "Aucune recherche récente.",
  "results: {n}": "résultats : {n}",
  "unknown time": "date inconnue",
  "Please enter your admin email and password.": "Saisissez votre e-mail et mot de passe admin.",
  "Admin sign-in failed.": "Échec de la connexion admin.",
  "Admin session": "Session admin",
  "You are already signed in": "Vous êtes déjà connecté",
  "Continue to the admin dashboard, moderation queues, or system overview.": "Accédez au tableau de bord et aux files de modération.",
  "Email": "E-mail",
  "Role": "Rôle",
  "Continue": "Continuer",
  "Sellers": "Vendeurs",
  "Parts": "Pièces",
  "Admin auth foundation": "Espace admin",
  "Sign in to admin panel": "Connexion à l'administration",
  "Access sellers moderation, parts review, order oversight, reviews moderation, and categories management.": "Modération des vendeurs, pièces et avis, suivi des commandes et gestion des catégories.",
  "Admin scope": "Périmètre admin",
  "Review sellers and marketplace activity.": "Vérifier les vendeurs et l'activité.",
  "Moderate parts, reviews, and operational flows.": "Modérer les pièces et les avis.",
  "Monitor categories, vehicles, and platform health.": "Suivre catégories, véhicules et santé de la plateforme.",
  "Admin Panel": "Administration",
  "Password": "Mot de passe",
  "Signing in...": "Connexion…",
  "Sign In": "Se connecter",
  "Admin-only access. Non-admin accounts will be rejected during authentication.": "Accès réservé aux administrateurs.",
  "Failed to load categories": "Impossible de charger les catégories",
  "Category name is required.": "Le nom de la catégorie est obligatoire.",
  "Category slug is required.": "Le lien (slug) est obligatoire.",
  "Category created successfully.": "Catégorie créée.",
  "Failed to create category": "Impossible de créer la catégorie",
  "Categories management": "Gestion des catégories",
  "Marketplace categories": "Catégories",
  "Manage the category structure used across parts listings and marketplace navigation.": "Gérez les catégories des annonces et de la navigation.",
  "Create category": "Créer une catégorie",
  "Add a new category for admin moderation and seller listing organization.": "Ajoutez une catégorie pour organiser les annonces.",
  "Category name": "Nom de la catégorie",
  "Brake System": "Système de freinage",
  "Slug": "Lien (slug)",
  "Parent category": "Catégorie parente",
  "No parent": "Aucune",
  "Icon": "Icône",
  "Creating...": "Création…",
  "Categories list": "Liste des catégories",
  "Current marketplace taxonomy used across product listings.": "Catégories utilisées par les annonces.",
  "Total": "Total",
  "Loading categories...": "Chargement des catégories…",
  "No categories found.": "Aucune catégorie.",
  "None": "Aucune",
  "Failed to load dashboard": "Impossible de charger le tableau de bord",
  "Queue healthy": "File à jour",
  "No moderation backlog detected right now.": "Aucun retard de modération.",
  "Needs attention": "À traiter",
  "Pending moderation items should be reviewed soon.": "Des éléments attendent une modération.",
  "Monitoring": "Surveillance",
  "Admin operations are being monitored.": "Les opérations sont surveillées.",
  "Admin command center": "Centre de contrôle",
  "Marketplace dashboard": "Tableau de bord",
  "Track moderation, supply growth, order activity, and marketplace health from one place.": "Modération, offre, commandes et santé de la plateforme au même endroit.",
  "Operational status": "État",
  "Total sellers": "Vendeurs",
  "All marketplace seller accounts": "Tous les comptes vendeurs",
  "Active parts": "Pièces actives",
  "Currently active catalog listings": "Annonces actives",
  "Total orders": "Commandes",
  "Marketplace order records": "Commandes",
  "Paid revenue": "Chiffre d'affaires payé",
  "Total revenue from paid orders": "Total des commandes payées",
  "Pending seller approvals": "Vendeurs à valider",
  "New or unresolved seller onboarding reviews": "Nouvelles boutiques à vérifier",
  "Pending part reviews": "Pièces à valider",
  "Listings waiting for marketplace approval": "Annonces en attente de validation",
  "Review seller queue": "Vendeurs à vérifier",
  "Approve trustworthy suppliers, reject weak submissions, and keep onboarding standards high.": "Validez les vendeurs fiables et refusez les dossiers faibles.",
  "Open seller moderation": "Modérer les vendeurs",
  "Review listing queue": "Annonces à vérifier",
  "Check parts waiting for approval and maintain data quality across the marketplace.": "Vérifiez les pièces en attente et la qualité des données.",
  "Open part moderation": "Modérer les pièces",
  "Moderate buyer reviews": "Modérer les avis",
  "Keep review quality high and remove low-value or harmful feedback before it goes live.": "Gardez des avis de qualité et retirez les avis abusifs.",
  "Open review moderation": "Modérer les avis",
  "Admin priorities": "Priorités",
  "1. Clear pending sellers": "1. Traiter les vendeurs en attente",
  "Seller verification is the first trust gate of the marketplace.": "La vérification des vendeurs est la première garantie de confiance.",
  "2. Approve high-quality parts": "2. Valider les bonnes annonces",
  "Better listing quality improves search trust and conversion quality.": "De meilleures annonces améliorent la confiance et les ventes.",
  "3. Monitor order flow": "3. Suivre les commandes",
  "Keep an eye on payment, shipping, and any order pipeline friction.": "Surveillez paiements, livraisons et blocages.",
  "Snapshot": "Aperçu",
  "Moderation load": "Charge de modération",
  "Supply base": "Offre",
  "Live catalog": "Catalogue en ligne",
  "Commercial activity": "Activité commerciale",
  "Revenue tracked": "Chiffre d'affaires",
  "Page not found": "Page introuvable",
  "This admin route does not exist or has not been implemented yet.": "Cette page n'existe pas.",
  "Go to dashboard": "Tableau de bord",
  "Failed to load orders": "Impossible de charger les commandes",
  "Orders overview": "Commandes",
  "Inspect order pipeline health and monitor marketplace fulfillment status.": "Suivez les commandes et leur traitement.",
  "Loading orders...": "Chargement des commandes…",
  "No orders available yet.": "Aucune commande.",
  "Order #{id}": "Commande n°{id}",
  "buyer: {name}": "acheteur : {name}",
  "unknown": "inconnu",
  "no email": "pas d'e-mail",
  "status: {status}": "statut : {status}",
  "payment: {status}": "paiement : {status}",
  "shipping: {status}": "livraison : {status}",
  "total: {price}": "total : {price}",
  "Failed to load part details": "Impossible de charger la pièce",
  "Failed to update part status": "Impossible de changer le statut",
  "Loading part details...": "Chargement de la pièce…",
  "Part not found": "Pièce introuvable",
  "Part details": "Détails de la pièce",
  "Review listing quality, fitment depth, and approval readiness.": "Vérifiez la qualité de l'annonce et sa compatibilité.",
  "Back to parts": "Retour aux pièces",
  "Approve": "Valider",
  "Reject": "Refuser",
  "Archive": "Archiver",
  "Message to seller:": "Message au vendeur :",
  "Slug:": "Lien :",
  "SKU:": "SKU :",
  "Not provided": "Non renseigné",
  "Seller:": "Vendeur :",
  "Unknown": "Inconnu",
  "Brand:": "Marque :",
  "Category:": "Catégorie :",
  "Price:": "Prix :",
  "Quantity:": "Quantité :",
  "Description": "Description",
  "No description available.": "Pas de description.",
  "Media": "Photos",
  "No media found for this part.": "Aucune photo.",
  "featured: {value}": "en vedette : {value}",
  "yes": "oui",
  "no": "non",
  "Compatibility": "Compatibilité",
  "No compatibility rows found.": "Aucune compatibilité.",
  "Specifications": "Caractéristiques",
  "No specifications available.": "Aucune caractéristique.",
  "Moderation guidance": "Conseils de modération",
  "• Approve listings with strong data quality and believable fitment information.": "• Validez les annonces complètes avec une compatibilité crédible.",
  "• Reject parts with weak, incomplete, or suspicious marketplace signals.": "• Refusez les annonces incomplètes ou suspectes.",
  "• Archive listings that should no longer appear in the active marketplace.": "• Archivez les annonces qui ne doivent plus apparaître.",
  "View seller profile": "Voir le vendeur",
  "Open the seller details page to review broader trust context.": "Ouvrez la fiche du vendeur pour plus de contexte.",
  "Open seller details": "Fiche du vendeur",
  "Failed to load parts": "Impossible de charger les pièces",
  "Part moderation": "Modération des pièces",
  "Review marketplace listings, approve high-quality parts, and reject poor or invalid submissions.": "Validez les bonnes annonces et refusez les mauvaises.",
  "Loading parts...": "Chargement des pièces…",
  "1 listing": "1 annonce",
  "{n} listings": "{n} annonces",
  "Loading moderation queue...": "Chargement…",
  "No parts found for this status.": "Aucune pièce avec ce statut.",
  "seller: {seller}": "vendeur : {seller}",
  "price: {price}": "prix : {price}",
  "No part description available.": "Pas de description.",
  "View details": "Voir le détail",
  "Failed to load reviews": "Impossible de charger les avis",
  "Failed to update review status": "Impossible de changer le statut de l'avis",
  "Review moderation": "Modération des avis",
  "Approve real buyer feedback and reject low-quality or policy-breaking reviews.": "Validez les vrais avis et refusez les avis abusifs.",
  "Loading reviews...": "Chargement des avis…",
  "No pending reviews right now.": "Aucun avis en attente.",
  "Unknown part": "Pièce inconnue",
  "rating: {n}/5": "note : {n}/5",
  "No review text provided.": "Pas de commentaire.",
  "Failed to load seller details": "Impossible de charger le vendeur",
  "Failed to update seller status": "Impossible de changer le statut du vendeur",
  "Loading seller details...": "Chargement du vendeur…",
  "Seller not found": "Vendeur introuvable",
  "Seller details": "Fiche du vendeur",
  "Review seller trust, listing quality, and onboarding status.": "Vérifiez la fiabilité et les annonces du vendeur.",
  "Back to sellers": "Retour aux vendeurs",
  "Suspend": "Suspendre",
  "Email:": "E-mail :",
  "Phone:": "Téléphone :",
  "WhatsApp:": "WhatsApp :",
  "Location:": "Localisation :",
  "Created at:": "Créée le :",
  "No seller description available.": "Pas encore de description.",
  "Seller parts": "Pièces du vendeur",
  "Review listings associated with this seller account.": "Annonces de ce vendeur.",
  "No parts found for this seller.": "Aucune pièce pour ce vendeur.",
  "• Approve sellers with complete identity and trustworthy listing quality.": "• Validez les vendeurs complets et fiables.",
  "• Suspend sellers when quality or response confidence is unclear.": "• Suspendez en cas de doute sur la qualité.",
  "• Reject weak onboarding when trust signals are too low.": "• Refusez les dossiers trop faibles.",
  "Quick actions": "Actions rapides",
  "Approve seller": "Valider le vendeur",
  "Suspend seller": "Suspendre le vendeur",
  "Reject seller": "Refuser le vendeur",
  "Failed to load sellers": "Impossible de charger les vendeurs",
  "Seller moderation": "Modération des vendeurs",
  "Review seller onboarding status, approve trusted suppliers, and suspend problematic accounts.": "Validez les vendeurs fiables et suspendez les comptes problématiques.",
  "All sellers": "Tous les vendeurs",
  "Loading sellers...": "Chargement des vendeurs…",
  "1 seller": "1 vendeur",
  "{n} sellers": "{n} vendeurs",
  "Loading seller moderation queue...": "Chargement…",
  "No sellers found for this filter.": "Aucun vendeur pour ce filtre.",
  "email: {email}": "e-mail : {email}",
  "phone: {phone}": "tél : {phone}",
  "n/a": "n/d",
  "No seller description provided yet.": "Pas encore de description.",
  "Failed to load vehicle makes": "Impossible de charger les marques",
  "Failed to load vehicle models": "Impossible de charger les modèles",
  "Failed to load vehicle years": "Impossible de charger les années",
  "Vehicles reference": "Référentiel véhicules",
  "Vehicle coverage explorer": "Couverture véhicules",
  "Review the current make, model, and year coverage available in the marketplace vehicle dataset.": "Marques, modèles et années disponibles.",
  "Makes loaded": "Marques",
  "Models shown": "Modèles",
  "Years shown": "Années",
  "Vehicle selector": "Choix du véhicule",
  "Inspect available models and years from the current dataset.": "Modèles et années disponibles.",
  "Make": "Marque",
  "Loading makes...": "Chargement des marques…",
  "Select make": "Choisir la marque",
  "Model": "Modèle",
  "Choose make first": "Choisissez d'abord la marque",
  "Loading models...": "Chargement des modèles…",
  "Select model": "Choisir le modèle",
  "Coverage details": "Détails",
  "Models": "Modèles",
  "No models loaded.": "Aucun modèle.",
  "Years": "Années",
  "Loading years...": "Chargement des années…",
  "No years loaded.": "Aucune année.",
  "Photos don't show the actual part. Please upload real photos.": "Les photos ne montrent pas la vraie pièce. Ajoutez de vraies photos.",
  "Title or description doesn't match the part shown.": "Le titre ou la description ne correspond pas à la pièce.",
  "Price looks wrong. Check it's entered in MAD.": "Le prix semble faux. Vérifiez qu'il est en MAD.",
  "Add vehicle compatibility for this vehicle-specific part.": "Ajoutez la compatibilité véhicule pour cette pièce.",
  "This item isn't allowed on PartHub.": "Ce produit n'est pas autorisé sur PartHub.",
  "Duplicate of another listing.": "Doublon d'une autre annonce.",
  "Out of stock for a long time.": "En rupture depuis longtemps.",
  "Store details are incomplete or unclear. Add a clear name, city and description.": "Informations incomplètes. Ajoutez un nom, une ville et une description clairs.",
  "We couldn't verify your contact number.": "Nous n'avons pas pu vérifier votre numéro.",
  "This store looks like a duplicate of an existing account.": "Cette boutique semble être un doublon.",
  "Repeated buyer complaints about delivered parts.": "Plaintes répétées des acheteurs.",
  "Listings don't match the parts delivered.": "Les annonces ne correspondent pas aux pièces livrées.",
  "Breach of the PartHub seller policy.": "Non-respect de la politique vendeur PartHub.",
  "Dashboard": "Tableau de bord",
  "Categories": "Catégories",
  "Vehicles": "Véhicules",
  "Orders": "Commandes",
  "Reviews": "Avis",
  "Analytics": "Analyses",
  "New": "Nouveau",
  "Used": "Occasion",
  "Refurbished": "Reconditionné",
  "Pending": "En attente",
  "Confirmed": "Confirmée",
  "Processing": "En préparation",
  "Shipped": "Expédiée",
  "Delivered": "Livrée",
  "Cancelled": "Annulée",
  "Paid": "Payée",
  "Unpaid": "Non payée",
  "Failed": "Échoué",
  "Refunded": "Remboursée",
  "Active": "Active",
  "Draft": "Brouillon",
  "Archived": "Archivée",
  "Rejected": "Refusée",
  "Suspended": "Suspendue",
  "Approved": "Validée",
  "Open for offers": "Ouverte",
  "Closed": "Fermée",
  "Fulfilled": "Pourvue",
  "Expired": "Expirée",
  "Accepted": "Acceptée",
  "Declined": "Refusée",
  "Withdrawn": "Retirée",
  "Not shipped": "Non expédiée",
  "In transit": "En transit",
};
